export const projects = [
  {
    id: 1,
    title: "Luxury Residential Villa",
    location: "Indore, Madhya Pradesh",
    category: "Residential",
    image: "/images/projects/project-1.png",
  },
  {
    id: 2,
    title: "Commercial Office Complex",
    location: "Indore, Madhya Pradesh",
    category: "Commercial",
    image: "/images/projects/project-2.png",
  },
  {
    id: 3,
    title: "Modern Apartment Development",
    location: "Indore, Madhya Pradesh",
    category: "Development",
    image: "/images/projects/project-3.png",
  },
  {
    id: 4,
    title: "Township Infrastructure Project",
    location: "Indore, Madhya Pradesh",
    category: "Infrastructure",
    image: "/images/projects/project-4.png",
  },
  {
    id: 5,
    title: "Eco-Friendly Housing Society",
    location: "Bhopal, Madhya Pradesh",
    category: "Residential",
    image: "/images/projects/project-1.png",
  },
  {
    id: 6,
    title: "City Center Retail Mall",
    location: "Indore, Madhya Pradesh",
    category: "Commercial",
    image: "/images/projects/project-2.png",
  },
  {
    id: 7,
    title: "Urban Industrial Park",
    location: "Pithampur, Madhya Pradesh",
    category: "Industrial",
    image: "/images/projects/project-3.png",
  },
  {
    id: 8,
    title: "Highway Extension Project",
    location: "Indore-Ujjain Highway",
    category: "Infrastructure",
    image: "/images/projects/project-4.png",
  },
];
